import React from "react";
import style from "./style/header.module.scss";
import logo from "../../assets/logocolor.png"
import gerb from "../../assets/gerb.png"
import theWorldBank from "../../assets/theWorldBank.png"
const  Header = () => {

    return (
        <header className={style.header}>
            <div className={style.headerBox}>
                <div className={style.kgms}>
                    <img src={gerb} alt="gerb"/>
                    <h1> Հայաստանի Հանրապետության <br/> կրթության, գիտության, մշակույթի և սպորտի <br/> նախարարություն </h1>
                </div>
                <div className={style.theWorldBank}>
                    <img src={theWorldBank}  alt="theWorldBank"/>
                    <h1>Համաշխարհային բանկի «Կրթության բարելավման ծրագրի լրացուցիչ ֆինանսավորում» վարկային ծրագիր  </h1>
                </div>
                <div className={style.logo}>
                    <img src={logo}  alt="logo"/>
                    <h1>ԽԱՉԱՏՈՒՐ ԱԲՈՎՅԱՆԻ ԱՆՎԱՆ <span>ՀԱՅԿԱԿԱՆ ՊԵՏԱԿԱՆ</span> ՄԱՆԿԱՎԱՐԺԱԿԱՆ ՀԱՄԱԼՍԱՐԱՆ</h1>
                </div>
            </div>

        </header>
    )
}
export default Header